// Use environment variable or default to localhost backend
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5004/api';

const handleResponse = async (response) => {
  const data = await response.json();
  
  if (!data.success) {
    throw new Error(data.error || 'API request failed');
  }
  
  return data.data;
};

export const faqAPI = {
  async getAll() {
    const response = await fetch(`${API_BASE_URL}/faq`);
    return handleResponse(response);
  },

  async search(query) {
    const response = await fetch(`${API_BASE_URL}/faq/search?q=${encodeURIComponent(query)}`);
    return handleResponse(response);
  },

  async create(faqData) {
    const response = await fetch(`${API_BASE_URL}/faq`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(faqData)
    });
    return handleResponse(response);
  },

  async update(id, faqData) {
    const response = await fetch(`${API_BASE_URL}/faq/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(faqData)
    });
    return handleResponse(response);
  },

  async delete(id) {
    const response = await fetch(`${API_BASE_URL}/faq/${id}`, {
      method: 'DELETE'
    });
    return handleResponse(response);
  }
}; 